function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.53 39.36l-4.12-3.19a2.36 2.36 0 002.2-2.33V14.56c0-1.9-2.2-3.03-3.79-1.93L33.6 18.3v10.29l-2.4-1.85V13.39c0-1.98-1.6-3.59-3.58-3.59H9.29L3.41 5.26a1.2 1.2 0 00-1.69.2L.25 7.37a1.2 1.2 0 00.21 1.68l2.74 2.11 28 21.65L44.6 43.15c.52.4 1.27.31 1.69-.21l1.47-1.9c.4-.52.31-1.28-.21-1.68zM2.4 35.02C2.4 37 4 38.6 5.98 38.6h21.63c.84 0 1.61-.3 2.22-.79L2.4 16.61V35z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
})))));